import { Button, makeStyles } from '@material-ui/core';
import { BlockRounded as BlockIcon, CheckCircleOutlineRounded as CheckCircleOutlineIcon } from '@material-ui/icons';

import { User } from '../../types/user.type';
import { UserRoleChip } from '../Chips/UserRole.chip';
import StatusChip from '../../../shared/components/Chips/StatusChip.component';

type Props = {
  user: User;
  onStatusActionClick: () => void;
};

const useStyles = makeStyles({
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',

    '& > h2': {
      margin: 0,
    },
  },

  statusButton: {
    marginLeft: 'auto',
    textTransform: 'none',
  },
});

export function UserDetailsHeader({ user, onStatusActionClick }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.header}>
      <h2>
        {user.firstname} {user.lastname}
      </h2>
      <UserRoleChip role={user.role} />
      <StatusChip isActive={user.isActive} inactiveLabel="Désactivé" />
      <Button
        size="small"
        variant="outlined"
        className={classes.statusButton}
        startIcon={user.isActive ? <BlockIcon /> : <CheckCircleOutlineIcon />}
        onClick={onStatusActionClick}
      >
        {user.isActive ? 'Désactiver' : 'Réactiver'}
      </Button>
    </div>
  );
}
